export default "__VITE_ASSET__DKpOydA7__"